/**
 * The customer's palette (#173), for the places that need a colour in code: the
 * colour a category is drawn in, and the choice offered for a status or a
 * priority.
 *
 * The same values as the tokens at the top of styles.css, which is where the
 * stylesheets take them from; a value changed here has to change there as well.
 * They are the brandbook's RGB values, not the HEX column printed beside them:
 * for seven of the colours the two disagree, and the RGB values are the ones in
 * the official logo and the rest of the brand material.
 */
export const PALETTE = {
    perzik: "#f19578",
    vuurrood: "#ee2e49",
    sinaasappel: "#f26522",
    zuurstokRoze: "#ee317f",
    viooltjesPaars: "#8b5a93",
    koningsblauw: "#1003a3",
    zeeblauw: "#4e81be",
    zwembadblauw: "#43c2d6",
    kikkergroen: "#59bd79",
    boomgroen: "#077a58",
    zonnigGeel: "#fbee34",
    /** the black of the logo */
    ink: "#221f20",
} as const;

export interface PaletteSwatch {
    /** The brandbook's own name for the colour, which is a name and not translated. */
    name: string;
    hex: string;
}

/** The colours a user may pick, in the brandbook's order. */
export const PALETTE_SWATCHES: PaletteSwatch[] = [
    { name: "Perzik", hex: PALETTE.perzik },
    { name: "Sinaasappel", hex: PALETTE.sinaasappel },
    { name: "Vuurrood", hex: PALETTE.vuurrood },
    { name: "Zuurstok roze", hex: PALETTE.zuurstokRoze },
    { name: "Viooltjes paars", hex: PALETTE.viooltjesPaars },
    { name: "Koningsblauw", hex: PALETTE.koningsblauw },
    { name: "Zeeblauw", hex: PALETTE.zeeblauw },
    { name: "Zwembadblauw", hex: PALETTE.zwembadblauw },
    { name: "Kikkergroen", hex: PALETTE.kikkergroen },
    { name: "Boomgroen", hex: PALETTE.boomgroen },
    { name: "Zonnig geel", hex: PALETTE.zonnigGeel },
];
